// 好评引导 URL 参数：review_flow / review_source，会话级存储
const SESSION_STORAGE_KEY = 'spyx_web_review_bridge'

// 同标签页内只自动开一次 chat，防刷新重复弹
const CHAT_HANDLED_KEY = 'spyx_review_chat_handled_v2'

// review_flow：用户点了差评(bad)还是好评(good)
export const REVIEW_FLOW = {
  BAD: 'bad',
  GOOD: 'good',
}

// review_source：从哪进来
export const REVIEW_SOURCE = {
  IOS_POPUP: 'ios_popup',
  ANDROID_POPUP: 'android_popup',
  EMAIL: 'email',
  BANNER: 'banner', // 预留：轮播
}

export const REVIEW_QUERY_KEYS = ['review_flow', 'review_source']

export const getReviewBridgeContext = () => {
  if (typeof window === 'undefined') return null

  try {
    return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY) || 'null')
  } catch {
    return null
  }
}

export const persistReviewBridgeFromQuery = (query = {}) => {
  if (typeof window === 'undefined') return

  const bridge = getReviewBridgeContext() || {}
  let updated = false

  REVIEW_QUERY_KEYS.forEach((key) => {
    const value = query[key]
    if (value === undefined || value === null || value === '') return

    bridge[key] = String(value)
    updated = true
  })

  if (!updated) return

  bridge.saved_at = Date.now()
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(bridge))
}

const getReviewFlow = (query = {}) => {
  if (query.review_flow) return String(query.review_flow)

  return getReviewBridgeContext()?.review_flow || ''
}

// 差评路径：Web 应自动打开 iTalks 客服
export const shouldOpenSupportChat = (query = {}) => getReviewFlow(query) === REVIEW_FLOW.BAD

export const isSupportChatHandled = () => {
  if (typeof window === 'undefined') return false

  return sessionStorage.getItem(CHAT_HANDLED_KEY) === '1'
}

export const markSupportChatHandled = () => {
  if (typeof window === 'undefined') return

  sessionStorage.setItem(CHAT_HANDLED_KEY, '1')
}

// 等 iTalks ChatPlugin 完整初始化后打开客服窗口。
// 启动脚本加载完成不代表 chat-plugin.js 已完成配置请求，因此轮询公开 API。
export const openSupportChat = ({ maxRetries = 60, intervalMs = 500 } = {}) =>
  new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(false)

      return
    }

    let attempts = 0

    const tryOpen = () => {
      attempts += 1

      const openWhenReady = window.ChatPlugin?.openWhenReady

      if (typeof openWhenReady === 'function') {
        try {
          Promise.resolve(openWhenReady.call(window.ChatPlugin, true))
            .then(result => resolve(result !== false))
            .catch(() => resolve(false))

          return
        } catch (error) {
          // ChatPlugin 尚未完成初始化，继续等待
        }
      }

      if (attempts >= maxRetries) {
        resolve(false)

        return
      }

      setTimeout(tryOpen, intervalMs)
    }

    tryOpen()
  })
